import { path } from "../path-browser";

if('File' in globalThis && globalThis['File']){
	const File:any=globalThis['File'];
	Object.defineProperty(File.prototype,
		'extname',
		{
			enumerable: false,
			value: function(){
				return path.extname(this.name);
			}
		}
	);
}
